import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactBootstrapCarousel from "react-bootstrap-carousel";
import { getPartnersNewsList } from "../../services/news/news.service";
import styles from "./Saham.module.css";
import Heading from "../../components/heading/heading";
import Title from "../../components/title";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import NewsBar from "../../components/product/NewsBar";
import { getPartnerSliderRequest } from "../../services/sliders";
import Slider from "../../components/slider/Slider";

const itemLinks = [
  {
    title: "نماد شرکت در بورس",
    link: "http://www.tsetmc.com/Loader.aspx?ParTree=151311&i=40505767672724777",
    external: true,
  },
  {
    title: "تماس با ما",
    link: "/about?t=IscIntroduction",
    external: false,
  },
];

const Saham = () => {
  const [news, setNews] = useState([]);
  const [slider, setSliders] = useState([]);
  const isMobile = useState(window.mobileCheck());

  useEffect(() => {
    getPartnersNewsList().then(({ data }) => {
      setNews((data && data.data) || []);
    });
    getPartnerSliderRequest().then(({ data }) => {
      setSliders((data && data.data) || []);
    });
  }, []);

  return (
    <>
      <Title title={"صفحه سهامداران"} />
      <Slider items={slider} attachedLinks={itemLinks} />
      <div id={styles.sahamNewsBox}>
        {!isMobile ? (
          <>
            <ReactBootstrapCarousel>
              {news && news.length > 0 ? (
                news.map((item, key) => (
                  <div className={"partners-news-item"}>
                    <NewsBar
                      key={key + "-product-bar"}
                      news={item}
                      isSahamdaran={true}
                    />
                  </div>
                ))
              ) : (
                <div className="loading-wrapper">
                  <img
                    src={"../../../assets/image/loading.svg"}
                    alt={"در حال بار گذاری"}
                  />
                </div>
              )}
            </ReactBootstrapCarousel>

            <div id={styles.loadMorePartnersNews}>
              <Link to={"/partners/news/list"}>آرشیو</Link>
            </div>
          </>
        ) : (
          ""
        )}
        <div className={"clearfix"}></div>
      </div>
      {isMobile ? (
        <div className={`${styles.shahamContainer} ${"container"}`}>
          <Heading title={"اخبار سهامداران"} />
          <div className="row">
            {news && news.length > 0 ? (
              news.map((item, key) => {
                return (
                  <div className="col-xs-12 col-sm-12 col-md-6 pull-right">
                    <NewsBar
                      key={key + "-product-bar"}
                      news={item}
                      isSahamdaran={true}
                    />
                  </div>
                );
              })
            ) : (
              <div className="loading-wrapper">
                <img
                  src={"../../../assets/image/loading.svg"}
                  alt={"در حال بار گذاری"}
                />
              </div>
            )}
          </div>
          <Link to={"/partners/news/list"} id={styles.loadMore}>
            <i className={"fa fa-plus"}></i> بیشتر
          </Link>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Saham;
